module.exports = __webpack_public_path__ + "static/media/Background.ca96800c.png";